/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import { pick } from 'underscore';
import { createSelector } from 'reselect';
import { getHasEmailWritePermissions, getHasFullEditorAccess } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
import { getHasUnpublishedChanges as _getHasUnpublishedChanges } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsSaveInProgress, getSaveData as getSaveDataCEUI } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getAllModuleSchemasAsArray, getModuleIdsByBuiltinType, getSchemaForModuleHelper } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { requestSucceeded, requestCompleted } from 'redux-request-state/util/requestStateCheckers';
import { getIsBlogOrRssEmail, getIsRecipientRequiringEmail, getIsAbTest, getIsAutomatedLike, getIsSubscriptionEmail, getShouldShowWorkflowsEditWarning, getJitterEnabled, getPreviewTextSpacingEnabled, getHasEngagementOptimizationAccess } from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getWidgetsFormattedForValidation, getElements, getEmailModules } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { createContentModelSelector, getContentModelCampaignValue, getContentModelCampaignName, getContentModelCampaignUtm, getContentModelDomain, getContentModelHtmlTitle, getContentModelName, getContentModelSlug, getContentModelMetaDescription, getContentModelPageExpiryDate, getContentModelPageExpiryEnabled, getContentModelPageExpiryRedirectId, getContentModelPageExpiryRedirectUrl, getContentState, getSubcategory, getTemplatePath, getContentAbTestPercentage, getContentAbSuccessMetric, getContentAbHoursToWait, getContentAbSampleSizeDefault, getContentAbSamplingDefault, getLanguage, getPublishDate, getPublishImmediatelyValue } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getCanSpamSettingsId, getSavedPlaintext, getReplyTo, getReplyToUserId, getCustomReplyToUserId, getCustomReplyTo, getCustomReplyToEnabled, getFromName, getSubject, getSmartRules, getIsTrackingDisabledForThisEmail } from 'EmailEditorUI/redux/selectors/EditSelectors';
import { getSendSpeedSaveData } from 'EmailEditorUI/StaggerSends/selectors/SaveSelectors';
import { getAiPersonalizationDefinitionIds } from 'EmailEditorUI/AIDynamicText/selectors/AIDynamicTextSelectors';
import { getSubscriptionId, getPreferencesGroupId, getIsTransactional, getScrubsSubscriptionLinks } from 'EmailEditorUI/redux/selectors/subscriptionSelectors';
import { getIsEngagementOptimizationEnabled, getSelectedContactQualityScoreSegment, getContactQualityScoreThresholdForSelectedSegment, getIsGraymailSuppressionEnabled, getIsRecipientFatigueSuppressionEnabled, getVidsIncluded, getVidsExcluded, getMailingIlsListsIncluded, getMailingIlsListsExcluded } from 'EmailEditorUI/redux/selectors/RecipientsSelectors';
import { getPreviewText, getPreviewTextModuleExists } from 'EmailEditorUI/redux/selectors/previewTextSelectors';
import { getIsWebversionEnabled } from 'EmailEditorUI/WebVersion/selectors/webversionSelectors';
import { getRssData, getUseRssHeadlineAsSubject } from 'EmailEditorUI/redux/selectors/BlogSelectors';
import { serializeWidget, makeGetModuleSaveData } from 'ContentEditorUI/redux/selectors/moduleSaveSelectors';
import { getContentFlexAreaSections, getContentFlexAreaStyles, getUserModuleDefaults } from 'ContentEditorUI/redux/selectors/moduleSelectorHelpers';
import { sanitizeSections } from 'EmailEditorUI/utils/dragDropModuleUtils';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { getIsDragDropEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getCanUseFlexAreas } from 'EmailEditorUI/redux/selectors/templateInfoSelectors';
import { getConditionallyPublishRequest } from 'EmailEditorUI/redux/selectors/requestStatesSelectors';
import { getContentFlexAreaStyleSettings } from './styleSettingsSelectors';
import { getSTOSaveData, getSTOSaveDataValidation, getContactSTOPublishDate } from 'EmailEditorUI/redux/selectors/scheduleSelectors';
import { getContactQualityScoreSegmentSelected } from 'EmailEditorUI/utils/engagementOptimizationUtils';
import { CONTACT_QUALITY_SCORE_SEGMENT } from 'EmailEditorUI/redux/actions/actionTypes';
import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
const emptyObj = {};
export const getNeedConditionalPublish = createSelector([getIsAutomatedLike, getIsBlogOrRssEmail, getIsSubscriptionEmail], (isAutomated, isBlogOrRss, isSubscription) => {
  return !(isAutomated || isBlogOrRss || isSubscription);
});
export const getSaveIsReady = createSelector([getConditionallyPublishRequest, getShouldShowWorkflowsEditWarning], (request, isShowingEditWarning) => {
  return requestSucceeded(request) && !isShowingEditWarning;
});
export const getSaveIsReadyPending = createSelector([getConditionallyPublishRequest], conditionalPublishRequest => {
  return !requestCompleted(conditionalPublishRequest);
});
export const getSubscriptionName = createContentModelSelector('subscriptionName');
export const getHeaderFooterModules = createContentModelSelector('headerFooterModules');
export const getAiFeatures = createContentModelSelector('aiFeatures');
export const getEmailType = createContentModelSelector('emailType');
const getContentModelSaveData = createSelector([getContentModelName, getSubscriptionId, getSubscriptionName, getPreferencesGroupId, getIsTransactional, getReplyTo, getCustomReplyTo, getCustomReplyToEnabled, getFromName, getSubject, getUseRssHeadlineAsSubject, getScrubsSubscriptionLinks, getContentModelCampaignValue, getContentModelCampaignName, getContentModelCampaignUtm, getSmartRules, getSavedPlaintext, getCanSpamSettingsId, getHeaderFooterModules, getPublishDate, getPublishImmediatelyValue, getLanguage, getTemplatePath, getContentModelDomain, getAiFeatures, getJitterEnabled, getPreviewTextSpacingEnabled, getAiPersonalizationDefinitionIds, getContactSTOPublishDate, getIsTrackingDisabledForThisEmail, getReplyToUserId, getCustomReplyToUserId], (contentModelName, subscriptionId, subscriptionName, preferencesGroupId, isTransactional, replyTo, customReplyTo, customReplyToEnabled, fromName, subject, useRssHeadlineAsSubject, scrubsSubscriptionLinks, contentModelCampaignValue, contentModelCampaignName, contentModelCampaignUtm, smartEmailFields, savedPlaintext, canSpamSettingsId, headerFooterModules, publishDate, publishImmediatelyValue, language, templatePath, contentModelDomain, aiFeatures, jitterEnabled, previewTextSpacingEnabled, aiPersonalizationKeyToDefinitionIds, contactCTOPublishDate, trackingSettingsValue, replyToUserId, customReplyToUserId) => {
  // Use contact CTO publish date if available, otherwise use original publish date
  // Note: The publishDate for the "Schedule" or "Now" options is currently handled in the ContentEditorUI repo.
  // Since we've consolidated everything related to Contact STO here, changing the architecture now could be
  // time-consuming. We can consider this as a chore or refactor item for better handling the contact STO
  // (e.g related of the publishDate) in the future
  const finalPublishDate = contactCTOPublishDate || publishDate;
  return {
    name: contentModelName,
    subscription: subscriptionId,
    subscription_name: subscriptionName,
    preferences_group_id: preferencesGroupId,
    transactional: isTransactional,
    reply_to: replyTo,
    reply_to_user_id: replyToUserId,
    custom_reply_to: customReplyTo,
    custom_reply_to_user_id: customReplyToUserId,
    custom_reply_to_enabled: customReplyToEnabled,
    from_name: fromName,
    subject,
    use_rss_headline_as_subject: useRssHeadlineAsSubject,
    scrubs_subscription_links: scrubsSubscriptionLinks,
    campaign: contentModelCampaignValue,
    campaign_name: contentModelCampaignName,
    campaign_utm: contentModelCampaignUtm,
    marketing_campaign_guids: [],
    disable_all_tracking: trackingSettingsValue,
    smart_email_fields: smartEmailFields,
    emailbody_plaintext: savedPlaintext,
    can_spam_settings_id: canSpamSettingsId,
    header_footer_modules: headerFooterModules,
    publish_date: finalPublishDate,
    publish_immediately: publishImmediatelyValue,
    language,
    template_path: templatePath,
    can_be_edited_in_embedded_editor: false,
    domain: contentModelDomain,
    aifeatures: aiFeatures,
    ai_personalization_key_to_definition_id: aiPersonalizationKeyToDefinitionIds,
    jitter_enabled: jitterEnabled,
    preview_text_spacing_enabled: previewTextSpacingEnabled
  };
});
const ONE_YEAR = 31540000000;
const getWebversionSaveData = createSelector([getContentModelHtmlTitle, getContentModelPageExpiryDate, getContentModelPageExpiryEnabled, getContentModelPageExpiryRedirectId, getContentModelPageExpiryRedirectUrl, getContentModelSlug, getContentModelMetaDescription, getIsWebversionEnabled, getHasFullEditorAccess, getIsBlogOrRssEmail], (htmlTitle, pageExpiryDate, pageExpiryEnabled, pageExpiryRedirectId, pageExpiryRedirectUrl, slug, metaDescription, enabled, hasFullEditorAccess, isBlogOrRss) => {
  return enabled ? {
    create_page: true,
    html_title: htmlTitle,
    page_title: htmlTitle,
    page_expiry_date: hasFullEditorAccess ? pageExpiryDate : Date.now() + ONE_YEAR,
    page_expiry_enabled: !isBlogOrRss && (!hasFullEditorAccess || pageExpiryEnabled),
    page_expiry_redirect_url: pageExpiryRedirectUrl,
    page_expiry_redirect_id: pageExpiryRedirectId,
    slug,
    meta_description: metaDescription
  } : {
    create_page: false
  };
});
const getAbTestSaveData = createSelector([getContentAbHoursToWait, getContentAbTestPercentage, getContentAbSuccessMetric, getContentAbSampleSizeDefault, getContentAbSamplingDefault], (abHoursToWait, abTestPercentage, abSuccessMetric, abSampleSizeDefault, abSamplingDefault) => ({
  ab_hours_to_wait: abHoursToWait,
  ab_test_percentage: abTestPercentage,
  ab_success_metric: abSuccessMetric,
  ab_sample_size_default: abSampleSizeDefault,
  ab_sampling_default: abSamplingDefault
}));
export const getOptimizerSaveData = createSelector([getHasEngagementOptimizationAccess, getIsEngagementOptimizationEnabled, getSelectedContactQualityScoreSegment, getContactQualityScoreThresholdForSelectedSegment], (hasEmailEngagementOptimizationFeature, isEngagementOptimizationEnabled, contactQualityScoreSegment, contactQualityScoreThreshold) => {
  if (!hasEmailEngagementOptimizationFeature) {
    return {
      is_engagement_optimization_enabled: false,
      contact_quality_score_segment: CONTACT_QUALITY_SCORE_SEGMENT.TOP_100_PERCENTILE_SEGMENT,
      contact_quality_score_threshold: null
    };
  }
  const isOptimizerEnabled = isEngagementOptimizationEnabled && getContactQualityScoreSegmentSelected(contactQualityScoreSegment);
  return {
    is_engagement_optimization_enabled: isOptimizerEnabled,
    contact_quality_score_segment: isOptimizerEnabled ? contactQualityScoreSegment : CONTACT_QUALITY_SCORE_SEGMENT.TOP_100_PERCENTILE_SEGMENT,
    contact_quality_score_threshold: isOptimizerEnabled ? contactQualityScoreThreshold : null
  };
});
const getRecipientsSaveData = createSelector([getIsGraymailSuppressionEnabled, getIsRecipientFatigueSuppressionEnabled, getVidsIncluded, getVidsExcluded, getMailingIlsListsIncluded, getMailingIlsListsExcluded, getIsRecipientRequiringEmail, getHasEngagementOptimizationAccess, getOptimizerSaveData], (isGraymailSuppressionEnabled, isRecipientFatigueSuppressionEnabled, vidsIncluded, vidsExcluded, mailingIlsListsIncluded, mailingIlsListsExcluded, isRecipientRequiringEmail, hasEmailEngagementOptimizationFeature, optimizerData) => {
  const alwaysIncludedFields = Object.assign({
    is_graymail_suppression_enabled: !hasEmailEngagementOptimizationFeature && isGraymailSuppressionEnabled || false,
    is_recipient_fatigue_suppression_enabled: isRecipientFatigueSuppressionEnabled === false ? false : null
  }, optimizerData);
  const data = isRecipientRequiringEmail ? Object.assign({}, alwaysIncludedFields, {
    vids_included: vidsIncluded,
    vids_excluded: vidsExcluded,
    mailing_ils_lists_included: mailingIlsListsIncluded,
    mailing_ils_lists_excluded: mailingIlsListsExcluded
  }) : Object.assign({}, alwaysIncludedFields);
  return data;
});
export const getRssSaveData = createSelector([getIsBlogOrRssEmail, getRssData], (isBlogOrRssEmail, rssSettings) => {
  if (!isBlogOrRssEmail) return {};
  const blogRssSettings = rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.blogRssSettings;
  const alwaysIncludedFields = {
    blog_rss_settings: blogRssSettings && Object.keys(blogRssSettings).length > 0 ? blogRssSettings : null,
    max_rss_entries: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.maxRssEntries,
    rss_email_by_text: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailByText,
    rss_email_click_through_text: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailClickThroughText,
    rss_email_comment_text: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailCommentText,
    rss_email_entry_template_enabled: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailEntryTemplateEnabled,
    rss_email_image_max_width: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailImageMaxWidth,
    rss_email_author_line_template: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailAuthorLineTemplate,
    rss_email_blog_image_max_width: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailBlogImageMaxWidth
  };
  return isBlogOrRssEmail ? Object.assign({}, alwaysIncludedFields, {
    rss_url: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssUrl,
    rss_email_entry_template: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssEmailEntryTemplate,
    rss_to_email_timing: rssSettings === null || rssSettings === void 0 ? void 0 : rssSettings.rssToEmailTiming
  }) : alwaysIncludedFields;
});
const getStateSaveData = createSelector([getContentState, getSubcategory, getEmailType], (state, subcategory, emailType) => ({
  state,
  subcategory,
  email_type: emailType
}));
export const getStyleSettingsSaveData = createSelector([getContentFlexAreaStyleSettings, getIsDragDropEmail, getUserModuleDefaults], (styleSettings, isDragDrop, userModuleDefaults) => {
  if (!isDragDrop) return emptyObj;
  const style_settings = styleSettings.toJS();
  style_settings.user_module_defaults = userModuleDefaults.toJS();
  // if user has set colour, make choice manual to display
  if (style_settings.body_border_color) {
    style_settings.body_border_color_choice = 'BORDER_MANUAL';
  }
  return {
    style_settings
  };
});
export const getFlexAreasSaveData = createSelector([getContentFlexAreaSections, getContentFlexAreaStyles, getElements, getCanUseFlexAreas], (flexAreaSections, flexAreaStyles, elements, templateContainsFlexArea) => {
  return templateContainsFlexArea ? {
    flex_areas: {
      main: Object.assign({}, flexAreaStyles.toJS(), {
        sections: sanitizeSections(flexAreaSections, elements).toJS()
      })
    }
  } : emptyObj;
});
const ALLOWLISTED_GLOBAL_FIELDS = ['id', 'name', 'type', 'body', 'module_id', 'definition_id', 'smart_type', 'smart_objects', 'styles'];
export const getEmailDDModuleSaveData = createSelector([getEmailModules, getAllModuleSchemasAsArray, getModuleIdsByBuiltinType], (modules, allModuleSchemasArray, moduleIdsByBuiltinType) => {
  const widgets = {};
  Object.entries(modules).forEach(([name, module]) => {
    if (module.get('type') !== 'fake') {
      const schema = getSchemaForModuleHelper(module, allModuleSchemasArray, moduleIdsByBuiltinType, CATEGORY_IDS.EMAIL);
      widgets[name] = schema && schema.global ? pick(module.toJS(), ALLOWLISTED_GLOBAL_FIELDS) : serializeWidget(module, schema);
    }
  });
  return {
    widgets
  };
});
const getEmailModuleSaveData = makeGetModuleSaveData(getEmailModules);
export const getModuleSaveData = createSelector([getEmailModuleSaveData, getEmailDDModuleSaveData, getCanUseFlexAreas], (moduleSaveData, emailDDModuleSaveData, templateContainsFlexArea) => {
  return templateContainsFlexArea ? Object.assign({}, moduleSaveData, {
    widgets: Object.assign({}, moduleSaveData.widgets, emailDDModuleSaveData.widgets)
  }) : moduleSaveData;
});
export const getStateSelectorForErrorHandling = createSelector([getRssSaveData, getStateSaveData, getPreviewText, getPreviewTextModuleExists, getContentModelSaveData, getWebversionSaveData, getAbTestSaveData, getRecipientsSaveData, getIsAbTest, getStyleSettingsSaveData, getModuleSaveData, getFlexAreasSaveData, getSTOSaveDataValidation, getSendSpeedSaveData], (rssSaveData, stateSaveData, previewText, previewTextModuleExists, contentModelSaveData, webversionSaveData, abTestSaveData, recipientsSaveData, isAbTest, styleSettingsSaveData, moduleSaveData, flexAreasSaveData, stoSaveData, sendSpeedSaveData) => {
  if (!isAbTest) {
    abTestSaveData = {};
  }
  const previewTextData = {};
  if (previewTextModuleExists) {
    previewTextData.preview_text = previewText;
  }
  return Object.assign({}, recipientsSaveData, contentModelSaveData, previewTextData, abTestSaveData, webversionSaveData, stateSaveData, rssSaveData, styleSettingsSaveData, moduleSaveData, flexAreasSaveData, stoSaveData, sendSpeedSaveData);
});
export const getSaveDataWithUpdateTimestamp = createSelector([getModuleSaveData, getStateSaveData, getContentModelSaveData, getWebversionSaveData, getRssSaveData, getAbTestSaveData, getRecipientsSaveData, getStyleSettingsSaveData, getFlexAreasSaveData, getSTOSaveData, getSendSpeedSaveData], (moduleSaveData, stateSaveData, contentModelSaveData, webversionSaveData, rssSaveData, abTestSaveData, recipientsSaveData, styleSettingsSaveData, flexAreasSaveData, stoSaveData, sendSpeedSaveData) => {
  const saveData = Object.assign({}, moduleSaveData, recipientsSaveData, contentModelSaveData, rssSaveData, webversionSaveData, abTestSaveData, stateSaveData, styleSettingsSaveData, flexAreasSaveData, stoSaveData, sendSpeedSaveData);
  return {
    updateTimestamp: Date.now(),
    saveData
  };
});
export const getSaveData = createSelector([getSaveDataWithUpdateTimestamp], ({
  saveData
}) => saveData);
export const getIsSaveDataPermanentlyDisabled = createSelector([getSaveDataCEUI], saveData => {
  return saveData.permanentlyDisabled;
});
export const getIsSavePermanentlyDisabled = createSelector([getSaveDataCEUI, getIsReadOnlyMode], (saveData, isReadOnlyMode) => {
  return saveData.permanentlyDisabled || isReadOnlyMode;
});
export const getCanSave = basicSelectorWithStats(state => {
  return getSaveIsReady(state) && getHasEmailWritePermissions(state) && !getIsSavePermanentlyDisabled(state) && !getIsReadOnlyMode(state);
});
export const getIsSavingEnabled = basicSelectorWithStats(state => {
  return getCanSave(state) && !getIsSaveInProgress(state);
});
export const getDataForValidation = createSelector([getStateSelectorForErrorHandling, getWidgetsFormattedForValidation, getFlexAreasSaveData], (stateForErrorHandling, widgets, flexAreas) => Object.assign({}, stateForErrorHandling, {
  widgets,
  flex_areas: flexAreas.flex_areas
}));
export const getTemplateDataForValidation = createSelector([getWidgetsFormattedForValidation, getFlexAreasSaveData], (all_widgets, flexAreas) => ({
  all_widgets,
  flex_areas: flexAreas.flex_areas
}));
export const getHasUnpublishedChanges = createSelector([_getHasUnpublishedChanges], hasBufferedChanges => {
  return hasBufferedChanges;
});